import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FilterGroup from 'components/search_sidebar/filter_group';
import FilterRow from 'components/search_page/filter_row';
import FilterTopbar from 'components/search_page/filter_topbar';
import Tag from 'components/tags/tag';

import { toggleView as toggleViewDuplicates } from '../../store/actions/duplicates';
import Button from 'shared/button';
import { faEraser } from '@fortawesome/pro-regular-svg-icons';

export class DuplicatesPageTopbar extends React.Component {
  static propTypes = {
    onToggleFindDuplicates: PropTypes.func.isRequired
  };

  handleHideDuplicatesView = () => {
    this.props.onToggleFindDuplicates(false);
  };

  render() {
    return (
      <FilterTopbar>
        <FilterRow>
          <div className="d-none d-md-block">
            <FilterGroup filtersApplied>
              <div className="d-flex align-items-center gap-2">
                <div>
                  <span className="text-muted">CURRENT FILTERS: </span>
                  <Tag name="duplicates-tag" removable onRemove={this.handleHideDuplicatesView}>Duplicates</Tag>
                </div>
                <Button.Primary
                  name="clear-all-filters-button"
                  plain
                  size="sm"
                  onClick={this.handleHideDuplicatesView}
                >
                  <FontAwesomeIcon className="ps-1" icon={faEraser} size="sm"/>
                  Clear All
                </Button.Primary>
              </div>
            </FilterGroup>
          </div>
        </FilterRow>
      </FilterTopbar>
    );
  }
}

const mapDispatchToProps = {
  onToggleFindDuplicates: toggleViewDuplicates
};

export default connect(null, mapDispatchToProps)(DuplicatesPageTopbar);
